module.exports = __webpack_public_path__ + "img/p3.828dbb83.jpg";